<div class="message-toolbar">
	<button
		type="button"
		class="ico"
		[class.ico-copy]="!copiedState"
		[class.ico-check]="copiedState"
		[attr.title]="'copy' | translate"
		(click)="handleCopy()"
	></button>

	@if (
		(feedbackAllowed && (state$ | async)?.isCommentVisible != true && !(state$ | async)?.submitted) || selectedFeedback
	) {
		<button
			type="button"
			class="positive ico ico-thumbs-up"
			[attr.title]="'chatbot.history.feedback.positive' | translate"
			(click)="rateUp()"
			[disabled]="(state$ | async)?.isSubmitting || (state$ | async)?.submitted"
			[class.selected]="(state$ | async)?.submitted && selectedFeedback"
		></button>
	}

	@if (feedbackAllowed && (!(state$ | async)?.submitted || !selectedFeedback)) {
		<button
			type="button"
			class="negative ico ico-thumbs-down"
			[attr.title]="'chatbot.history.feedback.negative' | translate"
			(click)="rateDown()"
			[disabled]="(state$ | async)?.isSubmitting || (state$ | async)?.submitted"
			[class.selected]="((state$ | async)?.submitted || (state$ | async)?.isCommentVisible) && !selectedFeedback"
		></button>
	}

	@if ((state$ | async)?.submitted) {
		<span class="feedback-thanks" [class.visible]="showThanks">
			<span>{{ "chatbot.history.feedback.success" | translate }}</span>
		</span>
	}

	@if ((state$ | async)?.error) {
		<span class="feedback-thanks" [class.visible]="showError">
			<span>{{ "chatbot.history.feedback.error" | translate }}</span>
		</span>
	}
</div>

<div class="feedback-comment">
	@if ((state$ | async)?.isCommentVisible) {
		<form [formGroup]="feedbackForm" (ngSubmit)="submitNegativeFeedbackForm()">
			<stages-input [input]="commentInput" [form]="feedbackForm" [hideLabel]="false" />
			<div class="feedback-actions">
				<stages-button
					[buttonType]="'button'"
					[title]="'cancel'"
					[buttonClasses]="'button sm cancel'"
					[disabled]="(state$ | async)?.isSubmitting ?? false"
					(clicked)="onCancel()"
				>
				</stages-button>
				<stages-button
					[buttonType]="'submit'"
					[title]="'send'"
					[buttonClasses]="'button sm save'"
					[disabled]="(!feedbackForm.valid || (state$ | async)?.isSubmitting) ?? false"
				>
				</stages-button>
			</div>
		</form>
	}
</div>
